// Woorden en kleine rekenregels van de trendlaag-weergave (ADR 2026-10-22-trends-
// bundelen, eindstand 23-10): "bronnen" = verschillende afzenders, labels alleen
// "Wet" en beweging, geen keurmerk-labels.

import type { Toon } from "../../stijl";
import type { TrendlaagOntwikkeling, TrendlaagTrend } from "../../lib/api";

const MAAND = ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"];

/** "2026-08-14" → "aug 2026"; zonder datum niets. */
export function maandJaar(d: string | null | undefined): string | null {
  if (!d || d.length < 7) return null;
  const m = Number(d.slice(5, 7));
  return m >= 1 && m <= 12 ? `${MAAND[m - 1]} ${d.slice(0, 4)}` : null;
}

/** Beweging als woord en kleur. Nooit "neemt af" (owner 23-10). */
export function beweging(label: string | null): { woord: string; toon: Toon } | null {
  switch (label) {
    case "groeit":
      return { woord: "groeit", toon: "groen" };
    case "stabiel":
      return { woord: "stabiel", toon: "neutraal" };
    case "minder recent bewijs":
      return { woord: "minder recent bewijs", toon: "oranje" };
    case "te weinig":
      return { woord: "nog weinig recent bewijs", toon: "neutraal" };
    default:
      return null;
  }
}

/** De twee meest voorkomende soorten van de ontwikkelingen, als woorden. */
export function soortenVan(t: TrendlaagTrend): string {
  const tel = new Map<string, number>();
  for (const o of t.ontwikkelingen) if (o.soort) tel.set(o.soort, (tel.get(o.soort) ?? 0) + 1);
  const top = [...tel.entries()].sort((a, b) => b[1] - a[1]).slice(0, 2).map(([s]) => s);
  return top.length ? top.join(" en ") : t.soortTrend === "arbeidsmarkt" ? "arbeidsmarkt" : "losse bevindingen";
}

/** De metaregel onder een trend: "onderwerp · N bronnen · soort · N ontwikkelingen". */
export function metaregel(t: TrendlaagTrend): string {
  const n = t.ontwikkelingen.length;
  return [
    t.onderwerp,
    `${t.bronnen ?? 0} bronnen`,
    soortenVan(t),
    `${n} ${n === 1 ? "ontwikkeling" : "ontwikkelingen"}`,
  ].join(" · ");
}

/** Regel R4: "5 bronnen · regel · sinds aug 2026". */
export function ontwMeta(o: TrendlaagOntwikkeling): string {
  const delen = [`${o.bronnen ?? 0} bronnen`];
  if (o.soort) delen.push(o.soort);
  // datum is de vroegste peildatum van de bronnen, geen ingangsdatum: dus "sinds", nooit "vanaf"
  const sinds = maandJaar(o.regelMetDatum ? o.datum : o.eerste);
  if (sinds) delen.push(`sinds ${sinds}`);
  if (o.opkomend) delen.push("opkomend");
  return delen.join(" · ");
}

/** "Wet" als minstens één ontwikkeling een regel met een genoemde datum is. */
export const heeftWet = (t: TrendlaagTrend): boolean => t.ontwikkelingen.some((o) => o.regelMetDatum);
